// import { combineReducers } from 'redux';
// import reader from './reader/readerReducer';
// import download from './download/downloadReducer';

var combineReducers = require('redux').combineReducers;
var reader = require('./reader/readerReducer');
var download = require('./download/downloadReducer');

module.exports = combineReducers({
    reader,
    download
});


// WEBPACK FOOTER //
// ./src/modules/reducer.js